module.exports = __webpack_public_path__ + "img/pool-count.48a5bb62.svg";